<template>
  <div>
    <b-row class="mb-5">
      <b-col cols="12">
        <b-card class="card-diagnostic">
          <template #header>
            <strong class="mb-0">
              Detalle del análisis del puesto de trabajo (APT)</strong
            >
          </template>
          <b-overlay :show="loading" rounded="sm">
            <template #overlay>
              <OverlayButton clase="overlay-md"> </OverlayButton>
            </template>
            <b-row class="">
              <b-col cols="6" class="mb-4">
                <Date
                  name="start_date"
                  label="Fecha de realización"
                  v-model="formData.start_date"
                  :value="formData.start_date"
                  :disabled="isEdit || isBusy"
                />
              </b-col>
              <b-col cols="6" class="mb-4">
                <UploadFile
                  @uploadFile="uploadFile1"
                  title="Adjunta aquí el archivo análisis del puesto de trabajo"
                  titleDocumento="Análisis del puesto de trabajo"
                  :isBusy="isBusy"
                  :isEdit="isEdit"
                  :document="file1"
                  :id="'file-diag-1'"
                />
              </b-col>
              <b-col cols="6" class="mb-4">
                <Date
                  name="request_date"
                  label="Fecha de solicitud"
                  v-model="formData.request_date"
                  :value="formData.request_date"
                  :disabled="isEdit || isBusy"
                />
              </b-col>
              <b-col cols="6" class="mb-4">
                <UploadFile
                  @uploadFile="uploadFile2"
                  title="Adjunta aquí el archivo de solicitud de APT"
                  titleDocumento="Solicitud de APT"
                  :isBusy="isBusy"
                  :isEdit="isEdit"
                  :document="file2"
                  :id="'file-diag-2'"
                />
              </b-col>
              <b-col cols="6" class="mb-4">
                <Date
                  name="delivery_date"
                  label="Fecha de entrega de documentos de APT"
                  v-model="formData.delivery_date"
                  :value="formData.delivery_date"
                  :disabled="isEdit || isBusy"
                />
              </b-col>
              <b-col cols="6" class="mb-4">
                <UploadFile
                  @uploadFile="uploadFile3"
                  title="Adjunta aquí el archivo de documentación de APT"
                  titleDocumento="Documentación de APT"
                  :isBusy="isBusy"
                  :isEdit="isEdit"
                  :document="file3"
                  :id="'file-diag-3'"
                />
              </b-col>
              <b-col cols="6" class="mb-4">
                <Select
                  label="Solicitantes"
                  name="applicant"
                  v-model="formData.applicant"
                  :options="entities"
                  :value="formData.applicant"
                  :disabled="isEdit || isBusy"
                />
              </b-col>
            </b-row>
          </b-overlay>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import useInputs from "@/components/general/Inputs";
import UploadFile from "./UploadFile";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";

const { Select, Date } = useInputs();
export default {
  components: {
    Select,
    Date,
    UploadFile,
    OverlayButton,
  },
  props: {
    entities: {
      type: Array,
      default: () => [],
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        applicant: null,
        start_date: "",
        request_date: "",
        delivery_date: "",
        work_analysis_file: null,
        apt_documentation_file: null,
        apt_request_file: null,
      },
      file1: null,
      file2: null,
      file3: null,
    };
  },
  watch: {
    formData: {
      handler() {
        this.$emit("changeForm", this.formData);
      },
      deep: true,
    },
    record() {
      const me = this;
      if (me.record) {
        me.fillData();
      }
    },
  },
  methods: {
    uploadFile1(file) {
      const me = this;
      me.formData.work_analysis_file = file;
    },
    uploadFile2(file) {
      const me = this;
      me.formData.apt_request_file = file;
    },
    uploadFile3(file) {
      const me = this;
      me.formData.apt_documentation_file = file;
    },
    fillData() {
      const me = this;
      me.formData.request_date = me.record?.request_date ? me.record?.request_date : "";
      me.formData.start_date = me.record?.start_date ? me.record?.start_date : "";
      me.formData.delivery_date = me.record?.delivery_date ? me.record?.delivery_date : "";

      if (me.record?.applicant) {
        me.formData.applicant = {
          id: me.record?.applicant_related?.id,
          name: me.record?.applicant_related?.info,
        }
      }

      me.file1 = me.record?.files?.work_analysis_file ? me.record?.files?.work_analysis_file : null;
      me.file2 = me.record?.files?.apt_request_file ? me.record?.files?.apt_request_file : null;
      me.file3 = me.record?.files?.apt_documentation_file ? me.record?.files?.apt_documentation_file : null;
    }
  },
};
</script>

<style lang="css">
.card-diagnostic .card-header {
  background: #f5f5f5 !important;
}
</style>
